import { defineMessages } from 'react-intl'

export default defineMessages({
  acquire: {
    id: 'SessionTimeOut.AcquireNewSession',
    defaultMessage: 'to acquire a new session.'
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  click: {
    id: 'Click',
    defaultMessage: 'Click'
  },
  draft: {
    id: 'SessionTimeOut.DraftMode',
    defaultMessage: "Don't worry, your notification will be saved in draft mode."
  },
  part1: {
    id: 'SessionTimeOut.SessionTimeOut',
    defaultMessage: 'Your session has timed out please'
  },
  part2: {
    id: 'SessionTimeOut.ThePageToAcquireNewSession',
    defaultMessage: 'the page to acquire a new session.'
  },
  refresh: {
    id: 'Refresh',
    defaultMessage: 'Refresh'
  },
  refreshLowerCase: { id: 'SessionTimeOut.refresh', defaultMessage: 'refresh' },
  title: {
    id: 'SessionTimeOut.SessionTimeOutTitle',
    defaultMessage: 'Session Timed Out'
  },
  twoMinutes: {
    id: 'SessionTimeOut.ExpireLessThan2',
    defaultMessage: 'Your session is about to expire in less than 2 minutes.'
  },
  warning: {
    id: 'SessionTimeOut.SessionTimeOutTitleWarning',
    defaultMessage: 'Session Timeout Warning'
  }
})
